<h2 class="span-titulo">Añadir Fotos y noticias</h2>

<div style="width: 500px;height: 210px;">
    <div layout="column">
        <div>
            <p class="title">Etapa:</p>
            <mat-form-field appearance="fill" class="componentStyle" style="margin-left: 120px;">
                <mat-label>Seleccione una Etapa</mat-label>
                <mat-select>
                <mat-option value="1">Etapa 1: Capacitación</mat-option>
                <mat-option value="2">Etapa 2: Autoevaluación</mat-option>
                <mat-option value="3">Etapa 3: Validación Externa</mat-option>
                <mat-option value="4">Etapa 4: Plan de Mejoramiento</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div>
            <p class="title">Tipo de Noticia:</p>
            <mat-radio-group aria-label="Select an option" (change)="radioChange($event)"  class="componentStyle">
                <mat-radio-button value="1" [checked]='true'>Texto</mat-radio-button>
                <mat-radio-button value="2" class="marginleft2">Imágen</mat-radio-button>
              </mat-radio-group>
        </div>
        <div *ngIf="isVisibleText">
            <p class="title" style="vertical-align: top;">Texto: </p>
            <mat-form-field class="example-full-width" class="componentStyle" style="width: 240px;margin-left: 120px;">
                <mat-label>Escriba aquí</mat-label>
                <textarea matInput placeholder="" matInput rows="5" cols="40" ></textarea>
              </mat-form-field>
        </div>
        <div *ngIf="isVisibleImg">
            <p class="title">Imagen: </p>
            <input class="componentStyle" class="ng-hide" id="input-file-id" multiple type="file" style="margin-left: 100px;"/>
            <label for="input-file-id" class="md-button md-raised md-primary"></label>
        </div>
    
    
    </div>

</div>



<mat-dialog-actions align="end">
    <button  mat-button mat-dialog-close back>Cerrar</button>
    <button mat-button [mat-dialog-close]="true">Guardar</button>
  </mat-dialog-actions>

